module.exports = __webpack_public_path__ + "img/brand-tbth.30320168.jpg";